module.exports = __webpack_public_path__ + "gw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gw.svg
// module id = 587
// module chunks = 0